import React from 'react';
import ReactDOM from 'react-dom';
import EventArchivePage from './EventArchive';

const rootElement = document.getElementById('dawn-ranch-events');

if (rootElement) {
	ReactDOM.render(
		<React.StrictMode>
			<EventArchivePage />
		</React.StrictMode>,
		rootElement
	);
}
